import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

export function createFirmQueries(client: StoxlyClient) {
  return createQueryKeys('firm', {
    // ['firm', 'detail', firmId]
    detail: (firmId: string) => ({
      queryKey: [firmId],
      queryFn: ({ signal }) => client.analystEntitiesGetFirm({ params: { id: firmId }, signal }),
    }),
  });
}
